import { render, staticRenderFns } from "./ProductSerialConfigurator.vue?vue&type=template&id=71d3bc64"
import script from "./ProductSerialConfigurator.vue?vue&type=script&lang=js"
export * from "./ProductSerialConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports